import { render, staticRenderFns } from "./ApprovalsPage.vue?vue&type=template&id=0adf34a8&scoped=true"
import script from "./ApprovalsPage.vue?vue&type=script&lang=ts"
export * from "./ApprovalsPage.vue?vue&type=script&lang=ts"
import style0 from "./ApprovalsPage.vue?vue&type=style&index=0&id=0adf34a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0adf34a8",
  null
  
)

export default component.exports